import { Box, Button } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  getApprovalListAsync,
  kycApprovalAsync,
} from '../ApprovalStore/approvalSlice';
import useToast from '../../../hooks/useToast';
import useApprovalModal from '../../../hooks/useApprovalModal';
import CloseIcon from '@material-ui/icons/Close';

function UserKycModalDetails() {
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleCloseApprovalModal } = useApprovalModal();
  const {
    userKycDetails,
    userKycDocDetails,
    userKycApprovalId,
    userKycApprovalStatus,
    userKycApiStatus,
    userDetails,
  } = useSelector(({ userKycApproveReducer }) => {
    return {
      userKycDetails: userKycApproveReducer.userKycDetails,
      userKycDocDetails: userKycApproveReducer.userKycDocDetails,
      userKycApprovalId: userKycApproveReducer.userKycApprovalId,
      userKycApprovalStatus: userKycApproveReducer.userKycApprovalStatus,
      userKycApiStatus: userKycApproveReducer.userKycApiStatus,
      userDetails: userKycApproveReducer.userDetails,
    };
  });

  const handleApprove = () => {
    dispatch(
      kycApprovalAsync({
        _id: userKycApprovalId,
        bodyData: { action: 'approved' },
      })
    )
      .unwrap()
      .then((res) => {
        // console.log({ res });
        dispatch(
          getApprovalListAsync({
            params: {
              entityType: 'kyc',
              approvalType: 'user-kyc-status',
              limit: 10,
              page: 1,
              statuses: [userKycApiStatus],
              latestFirst: true,
            },
            type: 'userKyc',
          })
        );
        SuccessToast('Approved!');
        handleCloseApprovalModal();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  const handleDisapprove = () => {
    dispatch(
      kycApprovalAsync({
        _id: userKycApprovalId,
        bodyData: { action: 'rejected' },
      })
    )
      .unwrap()
      .then((res) => {
        // console.log({ res });
        dispatch(
          getApprovalListAsync({
            params: {
              entityType: 'kyc',
              approvalType: 'user-kyc-status',
              limit: 10,
              page: 1,
              statuses: [userKycApiStatus],
              latestFirst: true,
            },
            type: 'userKyc',
          })
        );
        SuccessToast('Disapproved!');
        handleCloseApprovalModal();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  return (
    <Box
      px={8}
      py={6}
      bgcolor="white"
      fontFamily={'Rubik'}
      width="80vw"
      height={'80vh'}
      sx={{ overflowY: 'scroll' }}>
      {userKycDetails ? (
        <>
          <Box
            pb={2}
            borderBottom={`1px solid #dfdfdf`}
            mb={3}
            display="flex"
            width={'100%'}
            justifyContent="space-between">
            <Box fontSize={20} fontWeight="fontWeightMedium">
              User KYC
            </Box>
            <Box sx={{ cursor: 'pointer' }}>
              <CloseIcon fontSize="large" onClick={handleCloseApprovalModal} />
            </Box>
          </Box>
          {userDetails && (
            <Box mb={4}>
              <Box
                fontSize={20}
                fontWeight="fontWeightMedium"
                mb={2}
                sx={{ textDecoration: 'underline' }}>
                User Details
              </Box>
              <Box mb={2} display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  User Name:
                </Box>
                <Box fontSize={16}>{userDetails.name}</Box>
              </Box>
              <Box mb={2} display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  Email:
                </Box>
                <Box fontSize={16}>{userDetails.email}</Box>
              </Box>
              <Box mb={2} display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  Mobile:
                </Box>
                <Box fontSize={16}>{userDetails.mobile}</Box>
              </Box>
              <Box display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  User ID:
                </Box>
                <Box fontSize={16}>{userDetails._id}</Box>
              </Box>
            </Box>
          )}
          <Box
            fontSize={20}
            fontWeight="fontWeightMedium"
            mb={2}
            sx={{ textDecoration: 'underline' }}>
            User KYC Information
          </Box>
          <Box borderBottom={'1px solid #dfdfdf'} pb={2} mb={2}>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Status:
              </Box>
              <Box fontSize={16}>{userKycDetails.status}</Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Designation:
              </Box>
              <Box fontSize={16}>{userDetails && userDetails.role}</Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Date of Birth:
              </Box>
              <Box fontSize={16}>
                {moment(userKycDocDetails && userKycDocDetails[0].dob).format(
                  'MMMM Do, YYYY'
                )}
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Pancard Number:
              </Box>
              <Box fontSize={16}>
                {userKycDocDetails && userKycDocDetails[0].panCardNumber}
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Pancard Document:
              </Box>
              <Box fontSize={16}>
                <a
                  style={{ color: 'black' }}
                  href={
                    userKycDocDetails && userKycDocDetails[0].panCardDocument
                  }
                  target="_blank"
                  rel="noreferrer">
                  See Pancard Document
                </a>
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Created at:
              </Box>
              <Box fontSize={16}>
                {moment(userKycDetails.createdAt).format('MMMM Do, YYYY')}
              </Box>
            </Box>
            <Box mb={2} display={'flex'}>
              <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                Updated at:
              </Box>
              <Box fontSize={16}>
                {moment(userKycDetails.updatedAt).format('MMMM Do, YYYY')}
              </Box>
            </Box>
          </Box>
          <Box width={'100%'} display="flex" justifyContent={'flex-end'}>
            <Box mr={2}>
              <Button
                disabled={userKycApprovalStatus === 'approve'}
                onClick={handleDisapprove}
                variant="outlined"
                color="primary">
                Disapprove
              </Button>
            </Box>
            <Box>
              <Button
                disabled={userKycApprovalStatus === 'approve'}
                onClick={handleApprove}
                variant="contained"
                color="primary">
                Approve
              </Button>
            </Box>
          </Box>
        </>
      ) : null}
    </Box>
  );
}

export default UserKycModalDetails;
